import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaPaperPlane,
} from 'react-icons/fa';
import logo from "../assets/logo.png";

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Process', path: '/process' },
    { name: 'Requirements', path: '/requirements' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const services = [
    { name: 'Tourist Visas', path: '/services/tourist' },
    { name: 'Student Visas', path: '/services/student' },
    { name: 'Schengen Visas', path: '/services/schengen' },
    { name: 'Family Visas', path: '/services/family' },
    { name: 'Business Visas', path: '/services/business' },
    { name: 'Work Visas', path: '/services/work' },
  ];

  const countries = [
    'United States',
    'United Kingdom',
    'Canada',
    'Australia',
    'Germany',
    'France',
    'Japan',
    'Singapore',
  ];

  const socialLinks = [
    { icon: <FaFacebook />, name: 'Facebook', url: '#' },
    { icon: <FaTwitter />, name: 'Twitter', url: '#' },
    { icon: <FaInstagram />, name: 'Instagram', url: '#' },
    { icon: <FaLinkedin />, name: 'LinkedIn', url: '#' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-padding py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <div className="ml-3">
                <img src={logo} alt="Visa Agency Logo" className="h-8 w-auto" />
                <p className="text-sm text-gray-400">Experts in Visa Solutions</p>
              </div>
            </div>
            
            <p className="text-gray-400 mb-6">
              Your trusted partner for all visa and immigration services. 
              We make complex visa processes simple and stress-free.
            </p>
            
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-primary-600 transition"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition flex items-center"
                  >
                    <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.path}
                    className="text-gray-400 hover:text-white transition flex items-center"
                  >
                    <span className="w-2 h-2 bg-primary-600 rounded-full mr-3"></span>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact Info</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center">
                <FaMapMarkerAlt className="text-primary-400 mr-3" />
                <span className="text-gray-400">
                  Rose Arcade Plaza 3rd floor, Office no. 5<br />
                  G-11 Markaz, Islamabad                </span>
              </li>
              <li className="flex items-center">
                <FaPhone className="text-primary-400 mr-3" />
                <span className="text-gray-400">0313-5993810 | 051-2152050 | 051-2301470</span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-primary-400 mr-3" />
                <span className="text-gray-400">nextstepconsultant91@gmail.com</span>
              </li>
            </ul>

            <div>
              <h4 className="font-bold mb-3">Newsletter</h4>
              <p className="text-sm text-gray-400 mb-4">
                Subscribe for visa updates and travel tips
              </p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-grow px-4 py-2 rounded-l-lg text-gray-900 focus:outline-none"
                />
                <button className="bg-primary-600 px-4 py-2 rounded-r-lg hover:bg-primary-700 transition">
                  <FaPaperPlane />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} NextStep Consultants. All rights reserved.
            </p>
            
            <div className="flex flex-wrap gap-4 text-sm text-gray-400">
              <Link to="#" className="hover:text-white transition">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-white transition">
                Terms of Service
              </Link>
              <Link to="#" className="hover:text-white transition">
                Cookie Policy
              </Link>
              <Link to="#" className="hover:text-white transition">
                Sitemap
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;